/*
 * @Author: your name
 * @Date: 2021-06-22 16:38:06
 * @LastEditTime: 2021-06-22 16:38:06
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /HR_FE/src/config/website.js
 */
/**
 * 全局配置文件
 */
export default {
  title: 'AIIS HR',
  logo: 'A',
  key: 'AIIS_HR', // 配置主键,目前用于存储
  indexTitle: 'AIIS HR PLATFORM',
  clientId: 'saber', // 客户端id
  clientSecret: 'saber_secret', // 客户端密钥
  tenantMode: false, // 是否开启租户模式
  lockPage: '/lock',
  // 查看权限和操作权限最高的人
  showAllList: ['1244457842772324354', '1237617605370757121', '1265542340305788929'], // pm  qaqc qe
  operatingAll: ['1244457842772324354', '1237617605370757121', '1265542340305788929'], // pm  qaqc qe
  // 角色id
  qaqcManagerId: '1237617605370757121', // qaqc经理
  blockManagerId: '1246701154711453697', // 楼栋负责人
  projectManagerId: '1244457842772324354', // 项目负责人

  // RE
  REId: '1247821050899881985',

  generalContractor: '1237617508159373313', // 总包
  // 3种用户角色id
  contractorManagerId: '1237617768470462466',
  checkUserId: '1237617508159373313',
  rtoId: '1237617392446914562',
  tokenTime: 3000,
  // http的status默认放行不才用统一处理的,
  statusWhiteList: [],
  // 配置首页不可关闭
  isFirstPage: false,
  fistPage: {
    label: '登陆',
    value: '/login',
    params: {},
    query: {},
    meta: {
      i18n: 'dashboard',
    },
    group: [],
    close: false,
  },
  // 配置菜单的属性
  menu: {
    iconDefault: 'iconfont icon-caidan',
    props: {
      label: 'name',
      path: 'path',
      icon: 'source',
      children: 'children',
    },
  },
  // 流程设计器地址
  flowDesignUrl: 'http://localhost:9999',
  dateFormat: [
    {
      label: 'YYYY-MM-DD',
      value: 'YYYY-MM-DD',
    },
    {
      label: 'YYYY年MM月DD日',
      value: 'YYYY年MM月DD日',
    },
    {
      label: 'DD/MM/YYYY',
      value: 'DD/MM/YYYY',
    },
    {
      label: 'DD.MM.YYYY',
      value: 'DD.MM.YYYY',
    },
    {
      label: 'DD-MM-YYYY',
      value: 'DD-MM-YYYY',
    },
    {
      label: 'MM/DD/YYYY',
      value: 'MM/DD/YYYY',
    },
    {
      label: 'MM-DD-YYYY',
      value: 'MM-DD-YYYY',
    },
  ],
  staffProcessRouter: {
    1: '/staff/flow/employment/index',
    2: '/staff/flow/leave/index',
    4: '/staff/flow/interview/index',
    5: '/staff/flow/positive/index',
    6: '/staff/flow/induction/index',
    7: '/staff/flow/departure/index',
    8: '/staff/flow/fire/index',
    9: '/staff/flow/cancelHoliday/index',
    10: '/staff/flow/muddleheaded/index',
    11: '/staff/flow/evection/index',
    12: '/staff/flow/reimbursement/index',
    13: '/staff/flow/loan/index',
    14: '/staff/flow/officeEquipment/index',
    15: '/staff/flow/staffTraining/index',
    18: '/staff/flow/hrForm/index',
    // 24: '/worker/flow/leaveJob/index',
    // 离职
    24: '/worker/apply/list',
    26: '/worker/flow/transferDormitory/index',
    // 30: '/worker/flow/workerForm/index',
    // worker form
    30: '/worker/apply/list',
    31: '/worker/flow/course/index',
    // 28: '/worker/flow/passportApplication/index',
    // 护照
    28: '/worker/apply/list',
    27: '/worker/flow/courseApplication/index',
    // 29: '/worker/flow/leave/index',
    // 请假
    29: '/worker/apply/list',
    17: '/worker/flow/turnSiteApply/index',
    // 简易转场流程
    34: '/worker/apply/list',
    39: '/worker/apply/list',
    42: '/worker/apply/list',
  },
}
